export const site = {
  name: "Luisa Miceli",
  role: "Filosofa · Scrittrice · Poetessa · Digital Strategist",
  description:
    "Sito personale di Luisa Miceli: filosofa, scrittrice e poetessa. I suoi libri, la poesia, la riflessione sulla libertà femminile e il progetto A-Space Art.",
  email: null,
  instagram: "https://www.instagram.com/luisa_miceli_/",
  instagramASpace: "https://www.instagram.com/a_space_ita/",
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "Chi sono", to: "/chi-sono" },
  { label: "A-Space Art", to: "/a-space-art" },
  { label: "I miei libri", to: "/i-miei-libri" },
  { label: "Contatti", to: "/contatti" },
];

export const hero = {
  eyebrow: "Filosofa · Scrittrice · Poetessa · Digital Strategist",
  lines: ["Il pensiero libero", "è la forma più", "autentica di libertà."],
  sub: "Sono Luisa Miceli. Filosofa, scrittrice e professionista della comunicazione. Esploro il potere delle parole, la libertà delle donne e le possibilità di trasformazione attraverso il pensiero, l'arte e la scrittura.",
  ctas: [
    { label: "Scopri chi sono", to: "/chi-sono" },
    { label: "Esplora i miei libri", to: "/i-miei-libri" },
  ],
  portrait: "/images/luisa-biblioteca.jpg",
  portraitAlt: "Ritratto di Luisa Miceli in una biblioteca",
};

export const marquee = [
  "Filosofia",
  "Poesia",
  "Scrittura femminista",
  "A-Space Art",
  "Mindfulness",
  "Cultura digitale",
  "Libertà creativa",
];

export const quote = {
  text: "Essere libere significa smettere di chiedere al mondo il permesso di diventare noi stesse.",
  author: "Luisa Miceli",
};

export const STATI = [
  "Disponibile su Amazon",
  "In uscita",
  "In lavorazione",
  "In preparazione",
];

export const books = [
  {
    slug: "diario-di-una-figlia-ribelle",
    title: "Diario di una figlia ribelle",
    author: "Luisa Miceli",
    amazonTitle: "Edizione inglese: Diary of a Rebellious Daughter — Who stopped obeying",
    description:
      "«E se l'amore in cui eri cresciuta fosse costruito sull'obbedienza?» Il diario intimo di una donna che impara a mettere in discussione le regole invisibili dell'infanzia: l'obbedienza travestita da amore, la colpa travestita da moralità, il silenzio travestito da protezione.",
    descriptionLong:
      "«E se l'amore in cui eri cresciuta fosse costruito sull'obbedienza?» Da bambine impariamo a vedere i nostri genitori come dèi: potenti, infallibili, coloro che definiscono ciò che è giusto e chi ci è permesso diventare. Ma cosa succede quando gli dèi cadono? Nel diario, Luisa Miceli percorre il viaggio intimo di una donna che impara a mettere in discussione le regole invisibili che hanno plasmato la sua infanzia: l'obbedienza travestita da amore, la colpa travestita da moralità, il silenzio travestito da protezione. La sua ribellione non comincia con uno sbattere la porta: comincia con una domanda — chi sarei se smettessi di provare a essere amata? Attraverso i ricordi di famiglia, la scoperta della filosofia, della musica, della sessualità, della spiritualità e dell'amore, Luisa riprende possesso delle parti di sé che aveva imparato a reprimere. La libertà non è l'assenza di relazioni o di famiglia: è la decisione di smettere di tradire te stessa per appartenere. Tu non devi diventare la figlia che immaginavano: ti è permesso diventare te stessa.",
    genre: null,
    language: "Inglese",
    themes: "Obbedienza e ribellione, libertà femminile, identità",
    status: "Disponibile su Amazon",
    amazonUrl: "https://www.amazon.it/Luisa-Miceli-ebook/dp/B0HLM2GZKY",
    amazonPaperbackUrl: "https://www.amazon.it/Luisa-Miceli/dp/B0HJXRZNRP",
    coverImage: "/images/copertina-diario.jpg",
    coverTone: "bordeaux",
  },
  {
    slug: "fulmini-d-amore-sacro",
    title: "Fulmini d'amore sacro",
    author: "Luisa Miceli",
    amazonTitle: "Fulmini d'Amore Sacro: Poesie bilingui tra amore, desiderio e trascendenza",
    description:
      "Ci sono amori che non arrivano per salvarci: arrivano per incendiarci. Una raccolta poetica bilingue italiano-inglese che attraversa l'amore nelle sue forme più profonde e contraddittorie: il desiderio, la sensualità, l'assenza, la perdita, la memoria, la ferita e il risveglio interiore.",
    descriptionLong:
      "Ci sono amori che non arrivano per salvarci: arrivano per incendiarci. Fulmini d'Amore Sacro è una raccolta poetica bilingue italiano-inglese che attraversa l'amore nelle sue forme più profonde e contraddittorie: il desiderio, la sensualità, l'assenza, la perdita, la memoria, la ferita e il risveglio interiore. Attraverso versi intimi, visionari e filosofici, Luisa Miceli esplora il confine sottile tra corpo e anima, eros e spiritualità, dolore e trasformazione: l'amore diventa esperienza capace di mettere in discussione l'identità, il tempo e il significato stesso dell'esistenza. Due lingue, una sola voce: la versione italiana e quella inglese si incontrano pagina dopo pagina, permettendo alla poesia di attraversare confini linguistici e culturali senza perdere la sua intimità. Un libro da leggere lentamente. Una poesia alla volta. Un fulmine alla volta.",
    genre: "Poesia",
    language: "Italiano / Inglese",
    themes: "Amore, desiderio, trascendenza",
    status: "Disponibile su Amazon",
    amazonUrl: "https://www.amazon.it/Luisa-Miceli-ebook/dp/B0HJRQT6WV",
    amazonPaperbackUrl: "https://www.amazon.it/dp/B0HJRFPX8J",
    coverImage: "/images/copertina-fulmini.jpg",
    coverTone: "ink",
  },
];

export const home = {
  pensiero: {
    index: "01",
    title: "La filosofia come ricerca indipendente",
    text: "Filosofia, cultura, identità, libertà: come filosofa e ricercatrice indipendente interrogo il presente, con un'attenzione costante al ruolo delle donne nella società.",
    link: { label: "Chi sono", to: "/chi-sono" },
  },
  scrittura: {
    index: "02",
    title: "La scrittura",
    text: "Scrivo per interrogare il mondo, attraversare le contraddizioni e dare voce a ciò che troppo spesso rimane inespresso. La scrittura è per me uno spazio di ricerca, resistenza e possibilità.",
    link: { label: "I miei libri", to: "/i-miei-libri" },
    image: "/images/luisa-albero.jpg",
    imageAlt: "Luisa Miceli all'opera su un grande albero, in un momento di raccoglimento",
  },
  aspace: {
    index: "03",
    title: "A-Space Art",
    text: "A-Space Art nasce dall'incontro tra sensibilità creativa, ricerca interiore e desiderio di esplorare nuovi linguaggi. È uno spazio da costruire e attraversare attraverso idee, immagini, parole e possibilità espressive.",
    link: { label: "Scopri A-Space Art", to: "/a-space-art" },
    image: "/images/aspace-hero.jpg",
    imageAlt: "Composizione astratta di inchiostro terracotta e bordeaux su carta avorio",
  },
  libri: {
    index: "04",
    title: "I libri",
    link: { label: "Tutti i libri", to: "/i-miei-libri" },
  },
  contatti: {
    title: "Le idee migliori iniziano da un incontro.",
    text: "Invito editori, realtà culturali, collaboratori e lettori a entrare in relazione: scrivimi per costruire qualcosa insieme.",
    cta: "Entriamo in relazione",
  },
};

export const chiSono = {
  title: "Chi sono, oltre le definizioni.",
  subtitle:
    "Filosofia, parole e libertà: un percorso tra pensiero critico, creatività e comunicazione.",
  portrait: "/images/luisa-biblioteca.jpg",
  portraitAlt: "Ritratto di Luisa Miceli",
  bio: [
    "Luisa Miceli è filosofa, scrittrice, poetessa e digital strategist. La sua formazione filosofica costituisce il punto di partenza di un percorso che attraversa la cultura, la scrittura, la comunicazione e la ricerca sulle possibilità di trasformazione individuale e collettiva.",
    "Ha conseguito la laurea triennale in Filosofia e Scienze Umane, col massimo dei voti, presso l'Università di Messina, e la laurea magistrale in Scienze Filosofiche presso La Sapienza di Roma. Ha inoltre approfondito le competenze in Digital Strategy e Marketing.",
    "Accanto alla ricerca intellettuale, coltiva la scrittura poetica e narrativa, con particolare attenzione alla libertà femminile, all'identità, alle contraddizioni sociali e alla possibilità di ripensare i modelli culturali che influenzano le nostre vite.",
    "Il suo sguardo intreccia filosofia, sensibilità letteraria e pensiero femminista. La parola diventa uno strumento per interrogare il presente, mettere in discussione ciò che appare inevitabile e immaginare nuove forme di libertà.",
    "Si occupa inoltre di comunicazione digitale, strategia dei contenuti e progetti creativi. Integra nei suoi percorsi anche la pratica della mindfulness e della meditazione, coltivata e approfondita nel tempo.",
    "Il filo conduttore del suo lavoro è la ricerca: comprendere, creare, raccontare e aprire spazi di possibilità.",
  ],
  shortBio:
    "Luisa Miceli è filosofa, scrittrice e poetessa. Con una formazione in Scienze Filosofiche e competenze in Digital Strategy, intreccia pensiero critico, scrittura e comunicazione digitale, con uno sguardo particolare sulla libertà femminile e sulla ricerca interiore.",
  sections: [
    {
      id: "A",
      title: "Il pensiero",
      text: "La formazione filosofica, la ricerca culturale e l'interesse per il pensiero critico.",
      image: null,
      imageAlt: null,
      link: null,
    },
    {
      id: "B",
      title: "La scrittura",
      text: "La poesia, la narrativa e i libri: la scrittura come spazio di ricerca e resistenza.",
      image: null,
      imageAlt: null,
      link: { label: "I miei libri", to: "/i-miei-libri" },
    },
    {
      id: "C",
      title: "La libertà femminile",
      text: "L'interesse per il femminismo, l'autonomia, la voce delle donne e la critica dei modelli patriarcali.",
      image: "/images/luisa-albero.jpg",
      imageAlt: "Luisa Miceli all'opera su un grande albero",
      link: null,
    },
    {
      id: "D",
      title: "La comunicazione",
      text: "Le competenze in Digital Strategy, Marketing, Social Media Strategy, Content Creation e Digital Recruiting.",
      image: "/images/luisa-microfono.jpg",
      imageAlt: "Luisa Miceli davanti a un microfono professionale",
      link: null,
    },
    {
      id: "E",
      title: "La consapevolezza",
      text: "La mindfulness, la meditazione e il rapporto tra pensiero, corpo ed esperienza.",
      image: null,
      imageAlt: null,
      link: null,
    },
    {
      id: "F",
      title: "I progetti",
      text: "A-Space Art e i libri: i luoghi in cui la ricerca prende forma.",
      image: null,
      imageAlt: null,
      link: { label: "A-Space Art", to: "/a-space-art" },
      link2: { label: "I miei libri", to: "/i-miei-libri" },
    },
  ],
};

export const aspace = {
  eyebrow: "Progetto culturale e creativo",
  title: "A-Space Art — Uno spazio per creare, esplorare, trasformare.",
  intro:
    "A-Space Art nasce dall'incontro tra sensibilità creativa, ricerca interiore e desiderio di esplorare nuovi linguaggi. È uno spazio da costruire e attraversare attraverso idee, immagini, parole e possibilità espressive.",
  manifesto:
    "La missione di A-Space Art è favorire l'espansione della consapevolezza e del potenziale umano, utilizzando la bellezza e il dialogo interiore come strumenti di trasformazione. L'arte, in tutte le sue forme, è un potente strumento per veicolare ideali, risvegliare la consapevolezza e promuovere l'integrazione sociale.",
  heroImage: "/images/aspace-immersiva.jpg",
  heroImageAlt: "Evento immersivo di A-Space Art: pubblico e opere nella mostra",
  cofondazione:
    "Il progetto è cofondato da Luisa Miceli insieme a Victoria Markakis, performer e biologa antropologa.",
  sito: "https://aspaceart2.wixsite.com/ilmiosito",
  intro2:
    "A-Space Art crea mostre d'arte ed eventi immersivi in cui le foto e i quadri diventano il mezzo per risvegliare il senso del bello in ognuno di noi.",
  fondatriciTitle: "Le fondatrici",
  fondatrici: [
    {
      nome: "Luisa Miceli",
      ruolo: "Filosofa, Mindfulness Coach, Content Creator",
      foto: "/images/aspace-luisa2.jpg",
      fotoAlt: "Luisa Miceli, cofondatrice di A-Space Art",
    },
    {
      nome: "Victoria Markakis",
      ruolo: "Performer e biologa antropologa",
      foto: "/images/aspace-victoria.jpg",
      fotoAlt: "Victoria Markakis, cofondatrice di A-Space Art",
    },
  ],
  areeTitle: "Aree di ricerca",
  areeNote:
    "Le aree di ricerca indicano le direzioni in cui il progetto si orienta: non sono servizi già attivi.",
  aree: [
    { title: "Arte", text: "Immagini, materia e forme organiche come linguaggio." },
    { title: "Scrittura", text: "La parola come pratica creativa e di ricerca." },
    { title: "Creatività", text: "L'immaginazione come modo di abitare il reale." },
    { title: "Mindfulness", text: "Attenzione, contemplazione e presenza." },
    { title: "Editoria creativa", text: "Oggetti, testi e immagini pensati come opere." },
  ],
  gallery: [
    { src: "/images/aspace-linea.jpg", alt: "Disegno a linea continua di un profilo femminile con acquerello terracotta" },
    { src: "/images/aspace-carta.jpg", alt: "Quaderni di carta di cotone con disegni a inchiostro su lino sabbia" },
  ],
  eventiTitle: "Eventi",
  eventiNote: "Appuntamenti, interventi e partecipazioni di Luisa Miceli.",
  eventi: [
    {
      tipo: "Relatrice",
      titolo: "Il potere che cura: ripensare la leadership femminile oltre il paradigma patriarcale",
      anno: "Venerdì 11 settembre 2026",
      luogo: "Gavoi (NU) — Summer School «Pensare il femminile, pensare al femminile»",
      descrizione:
        "Intervento all'interno della Summer School organizzata dalla Società Filosofica Italiana – Sezione Universitaria Sassari, a cento anni dal Nobel a Grazia Deledda. Quando chiudiamo gli occhi e pensiamo a un leader, che volto vediamo? Nel 2025, quasi 4.000 persone hanno risposto a questa domanda in uno studio internazionale: nella nostra mente il potere ha ancora troppo spesso un volto maschile — non perché sia naturale, ma perché è l'immagine vista ripetersi così tante volte da aver quasi smesso di interrogarla. Da qui la domanda: possiamo immaginare un altro modo di esercitare il potere? Un potere che non sia dominio, ma relazione, responsabilità e cura.",
      image: "/images/evento-potere-cura.jpg",
      imageAlt: "Manifesto della Summer School «Pensare il femminile, pensare al femminile» con l'intervento di Luisa Miceli, «Il potere che cura»",
    },
  ],
  progettiTitle: "Progetti",
  progetti: [
    {
      tipo: "Mostra collettiva",
      titolo: "Riflessi di Donna",
      anno: "17 ottobre 2024",
      luogo: "Casa Internazionale delle Donne, Roma",
      descrizione:
        "Mostra organizzata da A-Space Art: un percorso che celebra l'essenza del femminile attraverso dipinti, disegni e fotografie di oltre 15 artisti internazionali, tra cui le fotografie di Luisa Miceli.",
    },
    {
      tipo: "Mostra collettiva",
      titolo: "La donna in divenire",
      anno: "Giugno 2025",
      luogo: "Gazometro, Roma",
      descrizione:
        "Nuova tappa della mostra collettiva di fotografia e pittura al Gazometro di Roma.",
    },
    {
      tipo: "Evento culturale",
      titolo: "Mutamenti",
      anno: "Gennaio 2025",
      luogo: "Zō Centro Culture Contemporanee, Catania",
      descrizione:
        "Evento culturale e mostra fotografica curata da Luisa Miceli: le immagini esplorano la «Dinamicità del Cambiamento», tra trasformazione, espansione della consapevolezza e riconnessione interiore, accompagnate da un concerto meditativo della musicista Sonia Brex.",
    },
  ],
  progettiEmpty:
    "Il progetto è all'inizio del suo percorso: i prossimi lavori verranno pubblicati in questa sezione.",
  collaborazioni: {
    title: "Collaborazioni e opportunità",
    text: "Sei un'artista, una realtà culturale, una casa editrice o uno spazio creativo? Scrivimi per costruire qualcosa insieme.",
    cta: "Proponi una collaborazione",
    to: "/contatti",
  },
};

export const contatti = {
  title: "Le idee migliori iniziano da un incontro.",
  text: "Per collaborazioni culturali, progetti editoriali, iniziative creative, comunicazione e proposte professionali, puoi scrivermi attraverso il modulo qui sotto.",
};
